import PaymentMethods from './payment-methods';

export default PaymentMethods;
